import { isMissing, isNumericType } from "@/profitability/missing";
import { compareValues } from "@/profitability/records/table-values";
import { reportNumber } from "@/profitability/report-number";
import type {
  ReportColumn,
  ReportRow,
  ReportValue,
} from "@/profitability/types";

const rank = (value: ReportValue | undefined, column: ReportColumn) => {
  if (isMissing(value)) return null;
  if (isNumericType(column.type)) return reportNumber(value);
  if (column.type === "boolean") return value ? 1 : 0;
  return String(value);
};

/**
 * Orders the rows a table shows. Numbers compare as numbers, dates as their
 * ISO text, and anything missing sinks to the bottom in either direction, so
 * sorting by margin never buries a job behind a column of blanks.
 */
export const sortRows = (
  rows: ReportRow[],
  column: ReportColumn | undefined,
  direction: "asc" | "desc",
) => {
  if (!column) return rows;
  return [...rows].sort((a, b) =>
    compareValues(
      rank(a[column.key], column),
      rank(b[column.key], column),
      direction,
    ),
  );
};
